import { CalculatedPrice } from 'rest-client';

import { ProductAvailabity } from './calculated-price.model';

export class SetCalculatedPriceAction {
  static readonly type = '[CALCULATED PRICE] Set calculated Price';
  constructor(public calculatedPrice: CalculatedPrice) { }
}

export class RemoveCalculatedPriceAction {
  static readonly type = '[CALCULATED PRICE] Remove calculate Price';
}

export class SetProductAvailabilityAction {
  static readonly type = '[CALCULATED PRICE] Set Product Availability';
  constructor(public product: ProductAvailabity) { }
}

export class RemoveAllProductsAvailability {
  static readonly type = '[CALCULATED PRICE] Remove All Products availability';
}

export class RemoveProductAvailability {
  constructor(public productId: number) { }
  static readonly type = '[CALCULATED PRICE] Remove Product availability';
}

export class SetAbsuidAction {
  static readonly type = '[CALCULATED PRICE] Set ABSUID';
  constructor(public absuid: string, public isParam: boolean) { }
}

export class SetTestParamsAction {
  static readonly type = '[CALCULATED PRICE] Set TestParams';
  constructor(
    public step: number,
    public experiment: string,
    public screenResolution: number
  ) { }
}

export class RemoveAbsuidAction {
  static readonly type = '[CALCULATED PRICE] Remove ABSUID';
}

export class RemoveTestParamsAction {
  static readonly type = '[CALCULATED PRICE] Remove TestParams';
}

export class SetCarServicesAction {
  static readonly type = '[CALCULATED PRICE] Storing Carservices List';
  constructor(public carServices: unknown) { }
}

export class RemoveCarServicesAction {
  static readonly type = '[CALCULATED PRICE] Remove Carservices List';
}
